@if (productId()) {
    <div class="flex min-h-0 w-full flex-col">
        <app-unit-conversion-config-link-list-widget
            #unitConversionConfigLinkListWidget
            [autoFocusSearch]="false"
            [vendorPriceListAddressLinkId]="vendorPriceListAddressLinkId()"
            [productId]="productId()"
            [variantParentId]="variantParentId()"
            [variantParentIdentifier]="variantParentIdentifier()"
            [inlineEditMode]="true"
            [noBaseEdit]="true"
            [addInDetail]="false"
            [baseUnit]="baseUnit()"
            [enableGlobalDeletion]="props?.enableGlobalDeletion ?? true"
        />
    </div>
} @else {
    <div
        class="flex justify-center items-center choose-ngifloader-splitter h-full w-full min-h-[400px]"
    >
        <div class="shine">
            <h3>{{ 'product.product-choose' | translate }}</h3>
        </div>
    </div>
}
